import React from "react";
import Withdraw from "../../component/withdraw";

export function Withdraww() {
  return  <Withdraw />
}
